import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    minWidth: 256,
    width: 300,
    maxWidth: `calc(100vw - ${theme.spacing(6)}px)`,

    '& .header': {
      '&-container': {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(0, 1),
        height: theme.spacing(8),
      },
      '&-logo': {
        '&-container': {
          display: 'flex',
          alignItems: 'center',
        },
        '&-img': {
          maxWidth: '70%',
          maxHeight: theme.spacing(7),
          objectFit: 'contain',
        },
      },
      '&-close': {
        margin: theme.spacing(0, 2, 0, 1),
        padding: theme.spacing(1),
      },
    },

    '& .list': {
      '&-title': {
        display: 'flex',
        padding: theme.spacing(0, 3),
        marginTop: theme.spacing(3),
        color: theme.palette.text.hint,
      },
    },
  },
}));

export default styles;
